var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700195 1.6998C0.700195 1.20275 1.10314 0.799805 1.6002 0.799805H12.4002C12.8973 0.799805 13.3002 1.20275 13.3002 1.6998V4.3998C13.3002 4.6385 13.2054 4.86742 13.0366 5.0362L8.8002 9.2726V12.4998C8.8002 12.7385 8.70537 12.9674 8.53659 13.1362L6.73659 14.9362C6.47919 15.1936 6.09209 15.2706 5.75578 15.1313C5.41947 14.992 5.2002 14.6638 5.2002 14.2998V9.2726L0.963799 5.0362C0.795016 4.86742 0.700195 4.6385 0.700195 4.3998V1.6998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7f66594170a258a24dc1e029d3b616d6.svg";
export { ForwardRef as ReactComponent };